module.exports = __webpack_public_path__ + "img/blog-09.429a5da8.jpg";